let LessonConstant = {
    created_by: {
        USER: 0,
        TEACHER: 1
    },
    type: {
        CANCEL_LESSON: 0,
        RESERVE_LESSON: 1
    },
    created_by_text: ["회원", "선생님"],
    type_text: ["취소", "예약"]
}
export default LessonConstant;